import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type {FC} from 'react';
import {useTranslation} from 'react-i18next';
import DialogPanel from '@/components/common/DialogPanel';

//TYPES
type Props = {
  onClose: () => void;
  onDelete: () => void;
};

const DeletingConfirmationDialog: FC<Props> = ({onClose, onDelete}) => {
  const {t} = useTranslation();

  const handleDelete = () => {
    onDelete();
    onClose();
  };

  return (
    <DialogPanel isOpen={true} label={t('pointClouds.notUndoTitle')} onClose={onClose}>
      <Stack direction="column" sx={{maxWidth: '350px', p: 1}}>
        <Typography gutterBottom>{t('pointClouds.notUndo')}</Typography>
        <Typography sx={{my: 2}}>{t('pointClouds.sure')}</Typography>
        <Stack direction="row" sx={{justifyContent: 'space-between', mt: 4}}>
          <Button variant="contained" onClick={onClose}>
            {t('cancel')}
          </Button>
          <Button onClick={handleDelete}>{t('pointClouds.delete')}</Button>
        </Stack>
      </Stack>
    </DialogPanel>
  );
};
export default DeletingConfirmationDialog;
